import { Icon, InputAdornment, Stack, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import { IGenericAutoComplete, IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { DataTypeAutoComplete } from "../autocomplete/dataType.autocomplete";

type FieldType = "autocomplete" | "text" | "date" | null;

interface ITableSearchInput {
    value: any,
    name: string,
    label: string;
    onChange: (event: any) => void,
    placeholder?: string,
    icon?: string;
}

interface IDropdownField extends IGenericAutoComplete {
    type: "autocomplete";
}

interface ITextField extends ITableSearchInput {
    type?: "text" | "date";
}

type SearchField = IDropdownField | ITextField;

export function SearchTableHeader(params: {
    inputs: Array<SearchField>,
}) {

    return (
        <Stack direction="row" spacing={2} sx={{ mb: 2, marginTop: "16px" }}>
            {(params.inputs && params.inputs.length) && params.inputs.map((m, i: number) =>
                <SearchTableInput key={`${i}_searchInput_${m.name}`} {...m} />
            )}
        </Stack>
    );
}

export function SearchTableInput(params: SearchField) {

    const [inputValue, setInputValue] = useState(params.value || '');
    const [initaialLoad, setInitaialLoad] = useState(false);

    useEffect(() => {
        if (!initaialLoad) {
            setInitaialLoad(true);
            return;
        }

        const timeout = setTimeout(() => {
            params.onChange((__filter: any) => {
                if (__filter[params.name] === inputValue) return __filter;
                return { ...__filter, [params.name]: inputValue };
            });
        }, 500);

        return () => clearTimeout(timeout);
    }, [inputValue]);

    function isTableDropdownInput(params: ITableSearchInput | IGenericAutoComplete): params is IGenericAutoComplete {
        return 'dataType' in params;
    }

    return (
        <>
            {!isTableDropdownInput(params) &&
                <TextField
                    label={params.label}
                    variant="outlined"
                    value={inputValue}
                    placeholder={params.placeholder || params.label}
                    name="search"
                    type={params.type || "text"}
                    onChange={(event: any) => { setInputValue(event.target.value); }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Icon>{params.icon || "search"}</Icon>
                            </InputAdornment>
                        ),
                    }}
                />
            }

            {isTableDropdownInput(params) &&
                <DataTypeAutoComplete {...params} onChange={(e) => {
                    params.onChange((__filter: any) => {
                        if (__filter[params.name] === e.target.value) return __filter;
                        return { ...__filter, [params.name]: e.target.value };
                    });
                }} hasFormsValidator={false} />
            }

        </>
    );
}